import React, { createContext, useContext, useMemo } from 'react';
import { CalendarManager } from './manager';

const Context = createContext();

const CalendarProvider = ({ fromDate, toDate, desks, children }) => {
  const manager = useMemo(() => {
    return new CalendarManager(fromDate, toDate, desks);
  }, [fromDate, toDate, desks]);

  return <Context.Provider value={manager}>{children}</Context.Provider>;
};

const useCalendarManager = () => useContext(Context);

export { CalendarProvider, useCalendarManager };
